// extracted by mini-css-extract-plugin
export default {"afa":"formicon_afa__xJLTs","headerLogoImage":"formicon_headerLogoImage__7vJ0d"};